"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _loadjs = _interopRequireDefault(require("loadjs"));
var _utils = require("./utils");
var _listener = _interopRequireDefault(require("./listener"));
var _adobeAppMeasurement = _interopRequireDefault(require("./adobeAppMeasurement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function init(_ref) {
  var url = _ref.url,
    cb = _ref.cb;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            (0, _utils.createEventDomElement)();
            (0, _adobeAppMeasurement.default)();
            _context.next = 4;
            return (0, _loadjs.default)([url], {
              returnPromise: true
            });
          case 4:
            cb && cb();
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}
var _default = function _default(_ref3) {
  var url = _ref3.url,
    cb = _ref3.cb;
  return {
    init: init({
      url: url,
      cb: cb
    }),
    listener: _listener.default
  };
};
exports.default = _default;